/**
 * @ngdoc Service
 * @name TimerService
 * @description Allows delegation of time sensitive functionality to a service whcih will call the callback and destroy the timer if desired.
 * @returns {Object}
 * @constructor
 */
export default function TimerService() {
  'ngInject';

  let intervals = [];

  /**
   * @name timerIdCreate
   * @description Recurse until a unique id has been generated. Also places the placeholder in the intervals array with the result as the key.
   * @returns {*} Unique key
   */
  function timerIdCreate() {
    let key = Math.random().toString(36).slice(2);
    if (key in intervals) {
      return timerIdCreate();
    }
    else {
      intervals[key] = undefined;
      return key;
    }
  }


  /**
   * @name add
   * @description Add a timer to the service.
   * @param callback The fn to be executed
   * @param condition The function that will be called every X ms to determine the state of the timers callback execution
   * @param interval The interval in which to check the condition function
   * @param destroy If true(default) the timer will destroy itself if false the timer will continue until the provided destroy function it called.
   * @return {function} A function that if called will destroy the timer.
   */
  function add(callback, condition, interval = 1000, destroy = true) {
    //Combination function
    let
      intervalId = timerIdCreate(),
      destroyFunction = function () {
        window.clearInterval(intervals[intervalId]);
      },
      intervalFunction = function () {
        //Check condition
        if (condition()) {
          //Call db
          callback();
          //Destroy it
          if (destroy) destroyFunction();
        }
      };
    intervals[intervalId] = window.setInterval(intervalFunction, interval);
    return destroyFunction;
  }

  return {
    add
  };

}



/** WEBPACK FOOTER **
 ** ./src/app/services/timer/timer.service.js
 **/